<template>
    <div class="d-flex flex-column bg-white">
        <HeaderBar/>
        <div class="d-flex justify-content-center mt-1 headTitle mt-4">Estado Económico</div>
        <b-card header-border-variant="Primary" class="shadow  px-0" no-body>
            <b-row no-gutters>

                <b-card-body>
                    <span style="font-weight: 600;font-size: 18px;">
                        
                        <div class="d-flex justify-content-between">
                            <b-form-datepicker id="fecha_ini" name="fecha_ini" v-model="init_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>

                            <b-form-datepicker id="fecha_fin" name="fecha_fin" v-model="end_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>
                            
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>Indicador Económico</div>
                            <div>Resultado</div>
                        </div>
                    </span>

                    <blockquote class="blockquote mb-0"></blockquote>

                    <b-card-text class="mt-3 mb-3">
                        <div class="d-flex justify-content-between">
                            <div> Ingresos:</div>
                            <div> ₡ {{formatPrice(incomes)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Gastos:</div>
                            <div> ₡ {{formatPrice(expenses)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Ingresos por animal:</div>
                            <div> ₡ {{formatPrice(animal_incomes)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Gastos por animal:</div>
                            <div> ₡ {{formatPrice(animal_expenses)}} </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div> Utilidad:</div>
                            <div> ₡ {{formatPrice(utility)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Margen de utilidad:</div>
                            <div> {{formatPrice(utility_margin)}} %</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Cantidad de animales vendidos:</div>
                            <div> # {{animals_sold}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>Gráficos Históricos</div>
                        </div>
                    <div class="d-flex justify-content-between mt-2 px-1">
                        
                        <b-button class="bg-primary w-50 mr-1" @click="showModal(1)">Ingresos</b-button>
                        <b-button class="bg-primary w-50 mr-1" @click="showModal(2)">Gastos</b-button>
                        <!-- <b-button class="bg-primary w-50 mr-1" @click="showModal(3)">Utilidad</b-button> -->
                    </div>
                    </b-card-text>
                </b-card-body>
                <div class="d-flex justify-content-between mt-1 mb-2 ">
                <BarChart
                    v-if="!isLoading && hasData"
                    :data="EconomicChartData"
                    :options="chartOptions"
                    :width="330" 
                    ref="EconomicBar"
                />
                </div>
                <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
                    <div v-if="!hasData">
                        <div class="d-flex justify-content-center mt-1 mb-2 text-center">
                            <h3>No hay datos para mostrar</h3>
                        </div>
                        <div class="d-flex justify-content-center mt-1 mb-2 text-center">
                            <img src="@/assets/images/ganImage/folder.png"  width="100" alt="">
                        </div>
                        
                    </div>
                    <div class="d-flex justify-content-center mt-1 mb-2 text-center">
                        <h3 v-if="report==1">Ingresos Históricos</h3>
                        <h3 v-if="report==2">Gastos Históricos</h3>
                        <h3 v-if="report==3">Utilidad Históricos</h3>
                    </div>
                    <EconomicLineChartVue v-if="report==2 && hasData"
                        :width="330" 
                        :data="ExpensesChartData"
                        :options="piechartOptions"
                    /> 
                    <EconomicLineChartVue v-if="report==1  && hasData"
                        :width="330" 
                        :data="IncomesChartData"
                        :options="piechartOptions"
                    /> 
                    <BarChart v-if="report==3  && hasData"
                        :width="330" 
                        :data="UtiltyChartData"
                        :options="piechartOptions"
                    /> 
                </b-modal>

            </b-row>
        </b-card>
        <ControlMenu />
    </div>
</template>


<script>
import { BCard, BRow, BCardBody, BCardText, BButton, BFormDatepicker, BFormRadio} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import HeaderBar from '@/components/HeaderBar.vue'
import Ripple from 'vue-ripple-directive'
import EconomicLineChartVue from '@/components/Basic/Reports/Economic/EconomicLineChart.vue';
import BarChart from '@/components/Basic/Reports/Economic/BarChart.vue';
export default {
    components: {
        BCard,
        BButton,
        BCardBody,
        BCardText,
        BRow,
        ControlMenu,
        HeaderBar,
        EconomicLineChartVue,
        BarChart,
        BFormRadio,
        BFormDatepicker

    },
    directives: {
    Ripple,
  },
  data(){
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate()+30)
    return{
        dateFormat:'%n/%Y',
        maxCfgDate:maxDate,
        minCfgDate:minDate,
        setLang:'es',
        init_date:now,
        end_date:now,
        isLoading: true,
        modalShow:false,
        hasData:false,
        report:"Mes",
        animals:0,
        animals_sold:0,
        animal_charge:0,
        dest_weight:0,
        animal_expenses:0,
        animal_incomes:0,
        incomes:0,
        avg_weight:0,
        expenses:0,
        milk:0,
        dayli:0,
        incomes:0,
        income_num:0,
        expenses:0,
        expenses_num:0,
        utility:0,
        utility_margin:0,
        EconomicChartData:{
            datasets: [
                {   label:'Ingresos',
                    backgroundColor: ['#5e8f238a'],
                    data:[0]
                },
                {   label:'Gastos',
                    backgroundColor: ['#ff0000a1',],
                    data:[0]
                }
            ]
        },
        ExpensesChartData:{
            labels:[],
            datasets: [
                {   
                    backgroundColor: [],
                    data:[]
                }
            ]
        },
        IncomesChartData:{
            labels:[],
            datasets: [
                {   
                    backgroundColor: [],
                    data:[]
                }
            ]
        },
        UtiltyChartData:{
            datasets: [
                {   label:'Ingresos',
                    backgroundColor: ['#5e8f23'],
                    data:[]
                },
                {   label:'Gastos',
                    backgroundColor: ['#ea5455',],
                    data:[]
                },
                {   label:'Utilidad',
                    backgroundColor: ['#102ef2',],
                    data:[]
                }
            ]
        },
        chartOptions:{
            responsive: false,
            maintainAspectRatio: false,
            hover: {
                mode: 'label',
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                    position: 'top',
                    align: 'start',
                    labels: {
                        usePointStyle: true,
                        padding: 25,
                        boxWidth: 9,
                    },
                },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel} (${tooltipItem.datasetIndex === 0 ? incomePercentage.toFixed(2) : expensePercentage.toFixed(2)}%)`;
                    }
                }
            }
        },
        piechartOptions:{
            responsive: false,
            maintainAspectRatio: false,
        },
    }
},
methods:{
    async fetchAnimals(config){
        let farmId= localStorage.getItem('currentFarm');
        let now = new Date()
        let initDate= this.init_date;
        let endDate= this.end_date;
        fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.animals = result.animals.length;
            console.log(this.animals);
            this.fetchIncomes(config, initDate,endDate);
        })
    },

    async fetchIncomes(config, initDate, endDate){
        this.isLoading=true;
        let solds=0;
        let farmId= localStorage.getItem('currentFarm');
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        fetch(this.$apiUrl+"list/economic_records?farm_id="+farmId+"&type=1", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.economic_records);
            this.incomes =result.economic_records.filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= initDateObj && itemRegDate<=endDateObj;
            }).map(
                item =>parseFloat(item.total)
            );
            if(this.incomes.length===0){
                this.incomes=0;
            }else{
                this.incomes= this.incomes.reduce(
                    (acc,amount )=>acc+amount
                );
            }
            result.economic_records.forEach(function(row){
                if(row.description=='Venta de Animal'){
                    solds=solds+1;
                }
            });
            this.animals_sold=solds;
            this.income_num =this.incomes;
            this.animal_incomes=parseFloat(parseFloat(this.income_num)/parseInt(this.animals));
        })
        console.log('Incomes filtered');
        console.log(this.incomes);

        fetch(this.$apiUrl+"list/BasicEconomicCategory?farm_id="+farmId+"&type=1", config)
        .then(response => response.json())
        .then(result => {
            console.log('Ingresos por categoria');
            console.log(result);
            
            if(result.totalRecordCount!=0){
                this.hasData=true
            }
            let totalData= result.BasicEconomicCategory.reduce((acc, item) => acc + parseFloat(item.total), 0);
            console.log('Total Data:'+totalData);
            this.IncomesChartData.datasets[0].data=result.BasicEconomicCategory.map(item=> {return item.total});
            this.IncomesChartData.labels=result.BasicEconomicCategory.map(item=> {return item.description +' '+ this.calculatePercentage(item.total,totalData)});
            
            this.IncomesChartData.datasets[0].backgroundColor=result.BasicEconomicCategory.map(item=> {return '#'+(Math.random()*0xFFFFFF<<0).toString(16)});
            console.log(this.IncomesChartData);
            this.fetchExpenses(config, initDate, endDate);
        })
    },

    async fetchExpenses(config, initDate, endDate){
        let farmId= localStorage.getItem('currentFarm');
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        fetch(this.$apiUrl+"list/economic_records?farm_id="+farmId+"&type=2", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.economic_records);
            this.expenses =result.economic_records.filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= initDateObj && itemRegDate<=endDateObj;
            }).map(
                item =>parseFloat(item.total)
            );
            if (this.expenses.length===0){
                this.expenses=0;
            }else{
                this.expenses=this.expenses.reduce(
                    (acc, total)=>acc+total
                );
            }
            this.expenses_num =this.expenses;
            this.animal_expenses=parseFloat(parseFloat(this.expenses_num)/parseInt(this.animals));
            console.log('animal expense')
            console.log(this.animal_expenses)
        })
        
        fetch(this.$apiUrl+"list/BasicEconomicCategory?farm_id="+farmId+"&type=2", config)
        .then(response => response.json())
        .then(result => {
            console.log('Gastos por categoria');
            console.log(result);
            if(result.totalRecordCount!=0){
                this.hasData=true
            }
            let totalData= result.BasicEconomicCategory.reduce((acc, item) => acc + parseFloat(item.total), 0);
            console.log('Total Data:'+totalData);
            this.ExpensesChartData.datasets[0].data=result.BasicEconomicCategory.map(item=> {return item.total});
            this.ExpensesChartData.labels=result.BasicEconomicCategory.map(item=> {return item.description +' '+ this.calculatePercentage(item.total,totalData)});
            this.ExpensesChartData.datasets[0].backgroundColor=result.BasicEconomicCategory.map(item=> {return '#'+(Math.random()*0xFFFFFF<<0).toString(16)});
            console.log(this.ExpensesChartData);
            this.calUtility();
        })
    },

    calUtility(){
        setTimeout(()=>{
            console.log('Utility and basic chart');
            this.utility=(this.incomes-this.expenses).toFixed(2);
            const incomePercentage = (this.incomes / (this.incomes + this.expenses)) * 100;
            const expensePercentage = (this.expenses / (this.incomes + this.expenses)) * 100;
            this.EconomicChartData.datasets[0].data=[this.incomes];
            this.EconomicChartData.datasets[1].data=[this.expenses];
            this.UtiltyChartData.datasets[0].data=[this.incomes];
            this.UtiltyChartData.datasets[1].data=[this.expenses];
            this.UtiltyChartData.datasets[2].data=[this.incomes-this.expenses];
            this.EconomicChartData.datasets[0].label=`Ingresos (${incomePercentage.toFixed(2)}%)`;
            this.EconomicChartData.datasets[1].label=`Gastos (${expensePercentage.toFixed(2)}%)`;
            console.log('EconomicChartData');
            console.log(this.EconomicChartData);
            console.log(this.utility);
            this.utility_margin= ((this.utility/this.incomes)*100).toFixed(2)
            //this.chart.update();
            //this.$refs.EconomicBar.chart.update();
            this.isLoading=false;
            this.hasData=true;
        },2000)
    },

    showModal(rep){
        this.modalShow=true;
        this.report=rep;
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    fillData(){
        this.isLoading=true;
        this.hasData=false;
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
        //this.fetchExpenses(config,dateReg);
    },
    calculatePercentage(data, total) {
        return ((data / total) * 100).toFixed(2)+'%';
    },
    dateFormatter(date, months){
        var month = date.getMonth();
        var year = date.getFullYear();
        var day = date.getDate();
        var lastDay = new Date(year, month, 0);
        if (month === 0) {
            month = 11;
            year = year - 1;
        } else {
            month = month - months;
        }
        if (day > lastDay.getDate()) {
            day = lastDay.getDate();
        }
        var newDate = new Date(year, month, 1);
        return newDate;
    }
  },
  watch:{
    'init_date': function(val){
        console.log(val);
        this.fillData();
    },
    'end_date': function(val){
        console.log(val);
        this.fillData();
    },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.fetchAnimals(config);
  },
}
</script>

<style>
.reportTitle {
    font-weight: 600;
    font-size: 24px;
}
.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}
.indicaterEco {
    font-weight: 500;
    font-size: 18px;
}
</style>